import { responseMiddleware } from "./alert";
import { fetchAuthenticatedResponse } from "./request";

export class HttpError extends Error {
    readonly name = "HttpError";

    constructor(
        readonly status: number,
        readonly resource: string,
        readonly body: unknown,
    ) {
        super(typeof body === "string" && body.trim() ? body : `Ошибка запроса (${status})`);
    }
}

export type JsonResponse<T> = { data: T; headers: Headers; status: number };

/** Unlike legacy request(), every unsuccessful HTTP status rejects and remains visible to Query. */
export async function jsonRequest<T = void>(resource: string, init: RequestInit = {}): Promise<JsonResponse<T>> {
    const { headers, ...params } = init;
    const response = await fetchAuthenticatedResponse(
        resource,
        { method: "GET", ...params },
        true,
        Object.fromEntries(new Headers(headers).entries()),
    );
    const text = await response.text();
    let data: unknown;
    if (text) {
        try {
            data = JSON.parse(text);
        } catch (error) {
            if (response.ok) {
                throw error;
            }
            data = text;
        }
    }
    if (!response.ok) {
        if ([401, 498, 503].includes(response.status)) {
            // Keep logout/license/maintenance navigation, without consuming an error as successful data.
            responseMiddleware(new Response(text || null, { status: response.status, headers: response.headers }), {});
        }
        throw new HttpError(response.status, resource, data);
    }
    if (data && typeof data === "object" && "@odata.context" in data && "value" in data) {
        data = data.value;
    }
    return { data: data as T, headers: response.headers, status: response.status };
}
